<template>
    <GoogleMap id="map" ref="GMap" :api-promise="apiPromise"
               style="width: 100%; height: 100%;"
               :scale-control="true" @idle="setupZoomControls"
               :zoom-control="!isMobile()" :pan-control="false" :camera-control="false"
               :center="center" :zoom="12" :streetViewControl="false" :fullscreenControl="false"
               :mapTypeControl="false" :styles="styles" :clickableIcons="false">
        <GPolygon v-for="area in extensiveOutageArea" :options="area" :key="hashArea(area)"
                  @click="renderInfoWindowOnClick(area, $event)"
                  @mouseover="renderInfoWindowOnHover(area, $event)"
                  @focus="renderInfoWindowOnHover(area, $event)"
                  @mouseout="hideInfoWindowOnMouseOut()"
                  @focusout="hideInfoWindowOnMouseOut()"/>
        <GPolygon v-for="area in areas" :options="area" :key="hashArea(area)"/>
        <GPolygon v-for="area in plannedOutageArea" :options="area" :key="hashArea(area)"/>
        <GPolygon v-for="area in confirmedOutageArea" :options="area" :key="hashArea(area)"/>
        <GPolygon v-for="area in plannedOutageAreaMaster" :options="area" :key="hashArea(area)"/>
        <MarkerCluster :options="userClusterOptions">
            <CustomMarker v-for="userReport in userReports.filter((el) => el.position !== null)"
                          :options="userReport"
                          :key="userReport.id"
                          @click="renderMarkerInfoWindowOnClick(userReport, $event)"
                          @mouseover="renderInfoWindowOnHover(userReport)"
                          @focus="renderInfoWindowOnHover(userReport)"
                          @mouseout="hideInfoWindowOnMouseOut()"
                          @focusout="hideInfoWindowOnMouseOut()">
                <div class="user-marker">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_4_6)">
                            <!-- eslint-disable-next-line max-len -->
                            <path d="M0 16C0 1.6 1.6 0 16 0C30.4 0 32 1.6 32 16C32 30.4 30.4 32 16 32C1.6 32 0 30.4 0 16Z" fill="#0075c2"/>
                            <!-- eslint-disable-next-line max-len -->
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.6611 19.542C23.7235 19.6199 23.7625 19.7136 23.7736 19.8124C23.7847 19.9112 23.7675 20.0111 23.7239 20.1007C23.6803 20.1902 23.6121 20.2658 23.5271 20.3187C23.4421 20.3717 23.3437 20.3998 23.2433 20.4H8.7569C8.6563 20.4003 8.55767 20.3724 8.47241 20.3195C8.38714 20.2666 8.31872 20.191 8.27504 20.1013C8.23135 20.0116 8.21419 19.9114 8.22553 19.8125C8.23687 19.7135 8.27625 19.6197 8.33913 19.542L9.228 18.442C10.0154 17.4671 10.4445 16.256 10.4447 15.0078V12.15C10.4447 10.8372 10.9714 9.57813 11.9091 8.64982C12.8468 7.72152 14.1185 7.2 15.4446 7.2H16.5557C17.8817 7.2 19.1535 7.72152 20.0911 8.64982C21.0288 9.57813 21.5556 10.8372 21.5556 12.15V15.0067C21.5555 16.2558 21.985 17.4678 22.7733 18.4431L23.6611 19.5409V19.542ZM18.2223 22.6H13.7779C13.7779 23.1835 14.012 23.7431 14.4288 24.1556C14.8455 24.5682 15.4108 24.8 16.0001 24.8C16.5895 24.8 17.1547 24.5682 17.5714 24.1556C17.9882 23.7431 18.2223 23.1835 18.2223 22.6ZM15.4446 5C13.5291 5 11.6922 5.7533 10.3378 7.09419C8.98336 8.43507 8.22247 10.2537 8.22247 12.15V15.0067C8.22247 15.7558 7.96469 16.484 7.49248 17.0681L6.6036 18.1681C6.2793 18.5695 6.07615 19.0535 6.01759 19.5643C5.95902 20.0751 6.04741 20.5918 6.27258 21.055C6.49774 21.5182 6.85052 21.909 7.29025 22.1823C7.72999 22.4557 8.23878 22.6005 8.75801 22.6H11.5557C11.5557 23.767 12.024 24.8861 12.8575 25.7113C13.6909 26.5364 14.8214 27 16.0001 27C17.1788 27 18.3093 26.5364 19.1428 25.7113C19.9762 24.8861 20.4445 23.767 20.4445 22.6H23.2444C23.7636 22.6 24.2722 22.4548 24.7116 22.1812C25.151 21.9075 25.5035 21.5166 25.7283 21.0533C25.9531 20.59 26.0411 20.0733 25.9822 19.5626C25.9234 19.052 25.72 18.5682 25.3955 18.167L24.5077 17.0681C24.0351 16.4829 23.7777 15.756 23.7778 15.0067V12.15C23.7778 11.211 23.591 10.2813 23.228 9.41381C22.8651 8.54634 22.3331 7.75813 21.6625 7.09419C20.9918 6.43025 20.1957 5.90358 19.3194 5.54426C18.4432 5.18494 17.5041 5 16.5557 5H15.4446Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_4_6">
                                <rect width="32" height="32" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </CustomMarker>
        </MarkerCluster>
        <CustomMarker v-for="area in plannedOutageArea"
                      :options="centerOfPolygon(area.paths)"
                      :key="area.name"
                      @click="renderMarkerInfoWindowOnClick(area, $event)"
                      @mouseover="renderInfoWindowOnHover(area)"
                      @focus="renderInfoWindowOnHover(area)"
                      @mouseout="hideInfoWindowOnMouseOut()"
                      @focusout="hideInfoWindowOnMouseOut()">
            <div class="planned-marker">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_4_7)">
                        <!-- eslint-disable-next-line max-len -->
                        <path d="M0 16C0 1.6 1.6 0 16 0C30.4 0 32 1.6 32 16C32 30.4 30.4 32 16 32C1.6 32 0 30.4 0 16Z" fill="#B00402"/>
                        <!-- eslint-disable-next-line max-len -->
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 6C16.2333 5.99995 16.4607 6.06599 16.6499 6.18876C16.8392 6.31153 16.9807 6.48481 17.0544 6.68402L19.4444 13.1422L25.27 15.0612C25.4839 15.1315 25.6687 15.2593 25.7993 15.4273C25.9299 15.5952 25.9999 15.7953 26 16.0002V18.0003C26 18.2655 25.8829 18.5199 25.6746 18.7074C25.4662 18.895 25.1836 19.0003 24.8889 19.0003C24.5942 19.0003 24.3116 18.895 24.1032 18.7074C23.8948 18.5199 23.7778 18.2655 23.7778 18.0003V16.6993L20.3444 15.5682L23.7211 24.6845C23.7904 24.8721 23.7964 25.074 23.7382 25.2646C23.6801 25.4553 23.5605 25.6262 23.3945 25.7556C23.2285 25.8851 23.0236 25.9674 22.8056 25.9922C22.5877 26.0169 22.3665 25.9829 22.17 25.8945L16.4967 23.3424C16.3424 23.2731 16.1724 23.237 16 23.237C15.8276 23.237 15.6576 23.2731 15.5033 23.3424L9.83 25.8945C9.63351 25.9829 9.41231 26.0169 9.19436 25.9922C8.97642 25.9674 8.7715 25.8851 8.6055 25.7556C8.43951 25.6262 8.31989 25.4553 8.26175 25.2646C8.20362 25.074 8.20958 24.8721 8.27889 24.6845L11.6556 15.5682L8.22222 16.6983V18.0003C8.22222 18.2655 8.10516 18.5199 7.89679 18.7074C7.68841 18.895 7.4058 19.0003 7.11111 19.0003C6.81643 19.0003 6.53381 18.895 6.32544 18.7074C6.11706 18.5199 6 18.2655 6 18.0003V16.0002C5.99977 15.7952 6.06957 15.5951 6.19994 15.4269C6.33032 15.2588 6.51498 15.1308 6.72889 15.0602L12.5556 13.1432L14.9467 6.68502C15.0201 6.48578 15.1614 6.31241 15.3505 6.18946C15.5395 6.06651 15.7668 6.00023 16 6ZM16 10.1621L17.0511 13.0002H14.9489L16 10.1621ZM11.2356 23.0264L12.7267 19.0003H19.2733L20.7644 23.0264L17.4911 21.5534C17.0282 21.345 16.5176 21.2365 16 21.2365C15.4824 21.2365 14.9718 21.345 14.5089 21.5534L11.2356 23.0264ZM18.5333 17.0003L17.7933 15.0002H14.2089L13.4689 17.0003H18.5333Z" fill="white"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4_7">
                            <rect width="32" height="32" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <span :class="area.name" class="marker-amount planned-marker-amount"></span>
        </CustomMarker>
        <CustomMarker v-for="area in plannedOutageAreaMaster"
                      :options="centerOfPolygon(area.paths)"
                      :key="area.name"
                      @click="renderMarkerInfoWindowOnClick(area, $event)"
                      @mouseover="renderInfoWindowOnHover(area)"
                      @focus="renderInfoWindowOnHover(area)"
                      @mouseout="hideInfoWindowOnMouseOut()"
                      @focusout="hideInfoWindowOnMouseOut()">
            <div class="planned-marker">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_4_7)">
                        <!-- eslint-disable-next-line max-len -->
                        <path d="M0 16C0 1.6 1.6 0 16 0C30.4 0 32 1.6 32 16C32 30.4 30.4 32 16 32C1.6 32 0 30.4 0 16Z" fill="#B00402"/>
                        <!-- eslint-disable-next-line max-len -->
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 6C16.2333 5.99995 16.4607 6.06599 16.6499 6.18876C16.8392 6.31153 16.9807 6.48481 17.0544 6.68402L19.4444 13.1422L25.27 15.0612C25.4839 15.1315 25.6687 15.2593 25.7993 15.4273C25.9299 15.5952 25.9999 15.7953 26 16.0002V18.0003C26 18.2655 25.8829 18.5199 25.6746 18.7074C25.4662 18.895 25.1836 19.0003 24.8889 19.0003C24.5942 19.0003 24.3116 18.895 24.1032 18.7074C23.8948 18.5199 23.7778 18.2655 23.7778 18.0003V16.6993L20.3444 15.5682L23.7211 24.6845C23.7904 24.8721 23.7964 25.074 23.7382 25.2646C23.6801 25.4553 23.5605 25.6262 23.3945 25.7556C23.2285 25.8851 23.0236 25.9674 22.8056 25.9922C22.5877 26.0169 22.3665 25.9829 22.17 25.8945L16.4967 23.3424C16.3424 23.2731 16.1724 23.237 16 23.237C15.8276 23.237 15.6576 23.2731 15.5033 23.3424L9.83 25.8945C9.63351 25.9829 9.41231 26.0169 9.19436 25.9922C8.97642 25.9674 8.7715 25.8851 8.6055 25.7556C8.43951 25.6262 8.31989 25.4553 8.26175 25.2646C8.20362 25.074 8.20958 24.8721 8.27889 24.6845L11.6556 15.5682L8.22222 16.6983V18.0003C8.22222 18.2655 8.10516 18.5199 7.89679 18.7074C7.68841 18.895 7.4058 19.0003 7.11111 19.0003C6.81643 19.0003 6.53381 18.895 6.32544 18.7074C6.11706 18.5199 6 18.2655 6 18.0003V16.0002C5.99977 15.7952 6.06957 15.5951 6.19994 15.4269C6.33032 15.2588 6.51498 15.1308 6.72889 15.0602L12.5556 13.1432L14.9467 6.68502C15.0201 6.48578 15.1614 6.31241 15.3505 6.18946C15.5395 6.06651 15.7668 6.00023 16 6ZM16 10.1621L17.0511 13.0002H14.9489L16 10.1621ZM11.2356 23.0264L12.7267 19.0003H19.2733L20.7644 23.0264L17.4911 21.5534C17.0282 21.345 16.5176 21.2365 16 21.2365C15.4824 21.2365 14.9718 21.345 14.5089 21.5534L11.2356 23.0264ZM18.5333 17.0003L17.7933 15.0002H14.2089L13.4689 17.0003H18.5333Z" fill="white"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4_7">
                            <rect width="32" height="32" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <span :class="area.name" class="marker-amount planned-marker-amount"></span>
        </CustomMarker>
        <CustomMarker v-for="area in confirmedOutageArea"
                      :options="centerOfPolygon(area.paths)"
                      :key="area.name"
                      @click="renderMarkerInfoWindowOnClick(area, $event)"
                      @mouseover="renderInfoWindowOnHover(area)"
                      @focus="renderInfoWindowOnHover(area)"
                      @mouseout="hideInfoWindowOnMouseOut()"
                      @focusout="hideInfoWindowOnMouseOut()">
            <div class="confirmed-marker">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_4_14)">
                        <!-- eslint-disable-next-line max-len -->
                        <path d="M0 16C0 1.6 1.6 0 16 0C30.4 0 32 1.6 32 16C32 30.4 30.4 32 16 32C1.6 32 0 30.4 0 16Z" fill="#EA1B0A"/>
                        <!-- eslint-disable-next-line max-len -->
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7651 17.7164C10.6273 17.7163 10.492 17.6789 10.3736 17.6081C10.2553 17.5373 10.1581 17.4358 10.0925 17.3143C10.0268 17.1928 9.99507 17.0558 10.0006 16.9177C10.0062 16.7796 10.0488 16.6456 10.124 16.5297L16.8049 6.25976C16.8773 6.1491 16.9856 6.06686 17.1114 6.02688C17.2372 5.9869 17.3729 5.99164 17.4957 6.04029C17.6184 6.08894 17.7207 6.17853 17.7853 6.29397C17.8498 6.4094 17.8727 6.54362 17.8501 6.67399L16.5853 13.8587H21.2349C21.3752 13.8587 21.5128 13.8974 21.6327 13.9705C21.7526 14.0437 21.8501 14.1485 21.9145 14.2734C21.979 14.3984 22.0079 14.5387 21.9982 14.6791C21.9884 14.8194 21.9404 14.9544 21.8592 15.0692L14.3076 25.7572C14.2296 25.8677 14.1152 25.947 13.9846 25.9813C13.854 26.0155 13.7155 26.0025 13.5935 25.9445C13.4715 25.8865 13.3738 25.7873 13.3176 25.6642C13.2614 25.5411 13.2503 25.4021 13.2862 25.2716L15.3795 17.7157H10.7667L10.7651 17.7164Z" fill="white"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4_14">
                            <rect width="32" height="32" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <span :class="area.name" class="marker-amount confirmed-marker-amount"></span>
        </CustomMarker>
        <InfoWindow ref="GMWindow" :options="{ pixelOffset: pixelOffset, disableAutoPan: disableAutoPan }"
                    @closeclick="deactivateMarker" />
        <!-- <GCircle ref="GMCircle" :options="circleOptions"/> -->
    </GoogleMap>
</template>

<script>
    import {

        getCallNetFailuresExtensive as getExtensiveOutages,
        getCallNetReports as getUserReports,
        getCallNetFailuresLV,
        getCallNetFailuresHV,
        getPublicAreas,
    } from "@/swagger/vue-api-client";
    import svgPlus from "@/components/form/svg/plus.svg";
    import svgMinus from "@/components/form/svg/minus.svg";
    import {
        // eslint-disable-next-line max-len
        GoogleMap, CustomMarker, MarkerCluster, InfoWindow, Polygon as GPolygon, Circle as GCircle, Polyline as GPolyline,
    } from "vue3-google-map";
    import {Loader} from "@googlemaps/js-api-loader";
    import {MapUtils} from "@/utils/MapUtils";
    import hash from "object-hash";
    import {TimeUtils} from "@/utils/TimeUtils";
    import {isMobile} from "@tenrok/vue3-device-detect";

    export default {
        name: "EonPublicMap",

        data() {
            return {
                api: null,
                apiPromise: null,
                circleOptions: MapUtils.createCircleOptions(),
                userClusterOptions: {renderer: MapUtils.userReportsClusterRenderer},
                plannedClusterOptions: {renderer: MapUtils.plannedReportsClusterRenderer},
                confirmedClusterOptions: {renderer: MapUtils.confirmedReportsClusterRenderer},
                userReports: [],
                plannedOutages: [],
                plannedOutagesMaster: [],
                confirmedOutages: [],
                extensiveOutages: [],
                confirmedPolylines: [],
                markerActive: false,
                activeAreaId: null,
                areas: null,
                mouseOnMarker: false,
                center: {lat: 52.232222, lng: 21.008333},
                styles: [
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#9d9d9d",
                            },
                        ],
                    },
                    {
                        featureType: "landscape",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#f6f6f4",
                            },
                        ],
                    },
                    {
                        featureType: "poi",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#fdfdfd",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels",
                        stylers: [
                            {
                                visibility: "simplified",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "transit",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "water",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#cad2d3",
                            },
                        ],
                    },
                    {
                        featureType: "water",
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#7a7a7a",
                            },
                        ],
                    },
                ],
                plannedOutageArea: [],
                extensiveOutageArea: [],
                plannedOutageAreaMaster: [],
                confirmedOutageArea: [],
                quater: 1,
                pixelOffset: {height: -30, width: 0},
                mouseX: null,
                mouseY: null,
                disableAutoPan: true,
                markerType: null,
            };
        },
        props: {
            centerProp: {
                default: {lat: 52.232222, lng: 21.008333},
            },
            userLocation: {
                default: {position: null},
            },
        },
        async beforeMount() {
            this.center = this.centerProp;
            const loader = new Loader({
                apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
                version: "weekly",
                libraries: ["places"],
            });
            this.apiPromise = loader.load();
            this.api = (await this.apiPromise).maps;
            await getPublicAreas().then((response) => {
                this.areas = MapUtils.adjustAreaOutlines(response.data);
            }).catch((error) => {
                console.log(error);
            });
            await getUserReports({timePeriod: "PT24H"}).then((response) => {
                this.userReports = MapUtils.adjustUserReportsMarkers(response.data.items);
                this.userReports.map((el) => { // eslint-disable-line
                    el.type = "WEB";
                    if (el.position === null) {
                        this.geocoder = new this.api.Geocoder();
                        this.geocoder.geocode({
                            address: el.address,
                        }, (results) => {
                            el.position = {
                                lat: results[0].geometry.location.lat(),
                                lng: results[0].geometry.location.lng(),
                            };
                        });
                    }
                });
            }).catch((error) => {
                console.log(error);
            });
            await getCallNetFailuresLV({body: {searchCriteria: {includedDate: TimeUtils.adjustTimezone(new Date())}}})
                .then((response) => {
                    const temporaryArrPlanned = [];
                    const temporaryArrFailure = [];
                    response.data.items.forEach((item) => {
                        if (item.type === "FAILURE") {
                            temporaryArrFailure.push(item);
                        } else if (item.type === "PLANNED") {
                            temporaryArrPlanned.push(item);
                        }
                    });
                    this.confirmedOutages = [
                        ...this.confirmedOutages,
                        ...MapUtils.adjustAreaOutageMarkers(temporaryArrFailure),
                    ];
                    this.plannedOutages = [
                        ...this.plannedOutages,
                        ...MapUtils.adjustAreaOutageMarkers(temporaryArrPlanned),
                    ];
                })
                .catch((error) => {
                    console.log(error);
                });
            await getCallNetFailuresHV({
                body:
                    {includedDate: TimeUtils.adjustTimezone(new Date()), status: "ACTIVE"},
            })
                .then((response) => {
                    const temporaryArrPlanned = [];
                    const temporaryArrFailure = [];
                    response.data.items.forEach((item) => {
                        if (item.type === "FAILURE") {
                            temporaryArrFailure.push(item);
                        } else if (item.type === "PLANNED") {
                            temporaryArrPlanned.push(item);
                        }
                    });
                    this.confirmedOutages = [
                        ...this.confirmedOutages,
                        ...MapUtils.adjustAreaOutageMarkers(temporaryArrFailure),
                    ];
                    this.plannedOutages = [
                        ...this.plannedOutages,
                        ...MapUtils.adjustAreaOutageMarkers(temporaryArrPlanned),
                    ];
                })
                .catch((error) => {
                    console.log(error);
                });
            await getExtensiveOutages({}).then((response) => {
                const temporaryArrFailure = [];
                response.data.items.forEach((item) => {
                    temporaryArrFailure.push(item);
                });
                this.extensiveOutages = [
                    ...MapUtils.adjustAreaOutageMarkers(temporaryArrFailure),
                ];
            }).catch((error) => {
                console.log(error);
            });
            for (let i = 0; i < this.confirmedOutages.length; i += 1) {
                this.confirmedOutageArea.push({
                    name: `Confirmed-${this.confirmedOutages[i].id}`,
                    paths: this.confirmedOutages[i].area,
                    options: {
                        strokeColor: "transparent",
                        fillColor: "#EA1B0A",
                    },
                    type: "CONFIRMED",
                    confirmedOutages: {...this.confirmedOutages[i]},
                });
                const dashSymbol = {
                    path: "M 0,-1 0,1",
                    strokeOpacity: 1,
                    scale: 2,
                };
                const polyLinePath = [...this.confirmedOutages[i].area, this.confirmedOutages[i].area[0]];

                this.confirmedPolylines.push({
                    path: polyLinePath,
                    options: {
                        geodesic: true,
                        strokeColor: "#00568f",
                        strokeOpacity: 0,
                        icons: [{
                            icon: dashSymbol,
                            offset: "0",
                            repeat: "10px",
                        }],
                    },
                    type: "CONFIRMED",
                });
                setTimeout(() => {
                    const markerAmount = document.querySelector(`.Confirmed-${this.confirmedOutages[i].id}`);
                    markerAmount.innerHTML = `${this.confirmedOutages[i].addressesCount > 99
                        ? "99+"
                        : this.confirmedOutages[i].addressesCount}`;
                    markerAmount.style.borderColor = "#EA1B0A";
                    markerAmount.style.color = "#EA1B0A";
                }, 1);
            }
            for (let i = 0; i < this.plannedOutages.length; i += 1) {
                this.plannedOutageArea.push({
                    name: `Planned-${this.plannedOutages[i].id}`,
                    paths: this.plannedOutages[i].area,
                    options: {
                        strokeColor: "transparent",
                        fillColor: "#B00402",
                    },
                    type: "PLANNED",
                    showDate: true,
                    plannedOutages: {...this.plannedOutages[i]},
                });
                setTimeout(() => {
                    const markerAmount = document.querySelector(`.Planned-${this.plannedOutages[i].id}`);
                    markerAmount.innerHTML = `${this.plannedOutages[i].addressesCount > 99
                        ? "99+"
                        : this.plannedOutages[i].addressesCount}`;
                    markerAmount.style.borderColor = "#B00402";
                    markerAmount.style.color = "#B00402";
                }, 1);
            }

            for (let i = 0; i < this.extensiveOutages.length; i += 1) {
                this.extensiveOutageArea.push({
                    name: `Extensive-${this.extensiveOutages[i].id}`,
                    paths: this.extensiveOutages[i].area,
                    options: {
                        strokeColor: "transparent",
                        fillColor: "#EA1B0A",
                        fillOpacity: 0.15,
                    },
                    type: "EXTENSIVE",
                    description: this.extensiveOutages[i].description,
                });
            }
        },

        async mounted() {
            await this.setupZoomControls();
            const map = document.getElementById("map");
            const windowWidth = window.innerWidth;
            if (windowWidth > 800) {
                map.addEventListener("mousemove", (e) => this.infoWindowPositioningDependOnMarkerPoistion(e));
                map.addEventListener("click", (e) => this.infoWindowPositioningDependOnMarkerPoistion(e));
            }
            if (windowWidth <= 800) {
                this.disableAutoPan = false;
            } else {
                this.disableAutoPan = true;
            }
        },

        watch: {
            api: {
                handler(newValue) {
                    this.$emit("update:api", newValue);
                },
            },
            // eslint-disable-next-line
            "userLocation.position"(newVal) {
                this.$refs.GMap.map.panTo(newVal);
                this.$refs.GMap.map.setZoom(15);
            },
        },

        methods: {
            isMobile() {
                return isMobile;
            },
            infoWindowPositioningDependOnMarkerPoistion(e) {
                const map = document.getElementById("map");
                const mapHeight = map.offsetHeight;
                const mapWidth = map.offsetWidth;

                this.mouseX = e.clientX;
                this.mouseY = e.clientY;

                if (this.mouseX < 350) {
                    this.pixelOffset.width = this.markerType === "WEB" ? 180 : 250;
                    this.pixelOffset.height = 10;
                } else if (this.mouseX > mapWidth - 500) {
                    this.pixelOffset.width = this.markerType === "WEB" ? -180 : -250;
                } else {
                    this.pixelOffset.width = 0;
                    this.pixelOffset.height = -30;
                }
                if (this.mouseY < 550) {
                    if (this.mouseX < 350 || this.mouseX > mapWidth - 500) {
                        this.pixelOffset.height = this.markerType === "WEB" ? 212 : 292;
                    } else {
                        this.pixelOffset.height = this.markerType === "WEB" ? 280 : 360;
                    }
                } else if (this.mouseY > mapHeight - 120) {
                    if (this.mouseX < 350 || this.mouseX > mapWidth - 500) {
                        this.pixelOffset.height = 20;
                    } else {
                        this.pixelOffset.height = -30;
                    }
                } else if ((this.mouseY >= 240 || this.mouseY <= mapHeight - 120)
                    && (this.mouseX < 350 || this.mouseX > mapWidth - 500)) {
                    this.pixelOffset.height = this.markerType === "WEB" ? 80 : 160;
                } else {
                    this.pixelOffset.height = -30;
                }
            },

            coorFromAddress(googleMapsApi, address) {
                if (googleMapsApi) {
                    this.geocoder = new googleMapsApi.Geocoder();
                    if (address) {
                        this.geocoder.geocode({
                            address,
                        }, (results) => {
                            this.coordinates = {
                                lng: results[0].geometry.location.lng(),
                                lat: results[0].geometry.location.lat(),
                            };
                            this.takeCoords(this.coordinates);
                        });
                    }
                }
            },

            centerOfPolygon(points) {
                const lng = points.map((i) => i.lng);
                const lat = points.map((i) => i.lat);

                lng.sort();
                lat.sort();

                const lowX = lng[0];
                const highX = lng[lng.length - 1];
                const lowY = lat[0];
                const highY = lat[lat.length - 1];

                const centerX = lowX + ((highX - lowX) / 2);
                const centerY = lowY + ((highY - lowY) / 2);

                return {position: {lng: centerX, lat: centerY}};
            },

            hashArea(area) {
                return hash(area);
            },

            reload(duration) {
                this.hideInfoWindowOnMouseOut();
                getUserReports({timePeriod: duration}).then((response) => {
                    this.userReports = MapUtils.adjustUserReportsMarkers(response.data.items);
                    this.userReports.map((el) => { // eslint-disable-line
                        el.type = "WEB";
                        if (el.position === null) {
                            this.geocoder = new this.api.Geocoder();
                            this.geocoder.geocode({
                                address: el.address,
                            }, (results) => {
                                el.position = {
                                    lat: results[0].geometry.location.lat(),
                                    lng: results[0].geometry.location.lng(),
                                };
                            });
                        }
                    });
                }).catch((error) => {
                    console.log(error);
                });
            },

            renderCircle(center) {
                this.$refs.GMCircle.circle.setCenter(center);
                this.$refs.GMCircle.circle.setVisible(true);
            },

            hideCircle() {
                this.$refs.GMCircle.circle.setVisible(false);
            },

            renderInfoWindow(marker, event) {
                if (marker.type === "PLANNED" || marker.type === "CONFIRMED") {
                    const center = this.centerOfPolygon(marker.paths);
                    this.$refs.GMWindow.infoWindow.setPosition(center.position);
                } else if (marker.type === "EXTENSIVE") {
                    const {latLng} = event;
                    this.$refs.GMWindow.infoWindow.setPosition({lng: latLng.lng(), lat: latLng.lat()});
                } else {
                    this.$refs.GMWindow.infoWindow.setPosition(marker.position);
                }
                this.$refs.GMWindow.infoWindow.setContent(MapUtils.createInfoWindowContent(marker, true));
                this.$refs.GMWindow.infoWindow.open(this.$refs.GMap.map);
            },
            renderInfoWindowOnHover(marker, event) {
                this.markerType = marker.type;
                this.mouseOnMarker = true;
                if (!this.markerActive) {
                    this.renderInfoWindow(marker, event);
                }
            },
            renderInfoWindowOnClick(marker, event) {
                this.markerType = marker.type;
                this.deactivateMarker();
                this.markerActive = true;
                this.renderInfoWindow(marker, event);
                // this.renderCircle(marker.position);
            },
            renderMarkerInfoWindowOnClick(marker, event) {
                this.markerType = marker.type;
                event.stopPropagation();
                this.renderInfoWindowOnClick(marker, event);
            },
            hideInfoWindowOnMouseOut() {
                this.markerType = null;
                this.mouseOnMarker = false;
                if (!this.markerActive) {
                    this.$refs.GMWindow.infoWindow.close(this.$refs.GMap.map);
                }
            },
            renderAreaOutage(outage) {
                if (outage.outageCircle === "SMALL") {
                    this.$refs.GMCircle.circle.setRadius(this.smallCircleRadius);
                } else if (outage.outageCircle === "MEDIUM") {
                    this.$refs.GMCircle.circle.setRadius(this.mediumCircleRadius);
                }
                this.deactivateMarker();
                this.markerActive = true;
                this.renderCircle(outage.position);
                this.renderInfoWindow(outage);
            },
            updateCenter(coords) {
                this.$refs.GMap.map.panTo(coords);
                this.$refs.GMap.map.setZoom(18);
            },

            async setupZoomControls() {
                await setTimeout(() => {
                    const elements = document.getElementsByTagName("gmp-internal-camera-control");
                    if (elements.length > 0) {
                        elements[0].style.display = "none";
                    }

                    Array.from(document.getElementsByClassName("gm-control-active")).forEach((button) => {
                        // Usunięcie tła.
                        button.parentElement.style.boxShadow = "";
                        button.parentElement.style.backgroundColor = "";

                        // Zmiana plusa/minusa na ten z figmy.
                        if (button.title === "Zoom in" || button.title === "Powiększ") {
                            Array.from(button.children).forEach((child) => {
                                child.src = svgPlus;
                            });
                        } else if (button.title === "Zoom out" || button.title === "Pomniejsz") {
                            Array.from(button.children).forEach((child) => {
                                child.src = svgMinus;
                            });
                        }
                        const iconSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                        const iconPath = document.createElementNS(
                            "http://www.w3.org/2000/svg",
                            "path",
                        );

                        if (button.getAttribute("aria-label") === "Zoom in"
                            || button.getAttribute("aria-label") === "Powiększ") {
                            button.style.setProperty("top", "-4px");
                        }

                        iconSvg.setAttribute("fill", "none");
                        iconSvg.setAttribute("viewBox", "0 0 48 48");
                        iconSvg.setAttribute("width", "40");
                        iconSvg.setAttribute("height", "40");
                        iconPath.setAttribute(
                            "d",
                            // eslint-disable-next-line max-len
                            "M7.76825 1.544C6.22594 1.83684 4.80747 2.5871 3.69741 3.69716C2.58735 4.80723 1.83709 6.22569 1.54425 7.768C-0.51475 18.589 -0.51475 29.411 1.54425 40.232C1.83709 41.7743 2.58735 43.1928 3.69741 44.3028C4.80747 45.4129 6.22594 46.1632 7.76825 46.456C13.1184 47.4794 18.5531 47.9964 24.0002 48C29.4474 47.9964 34.8821 47.4794 40.2323 46.456C41.7746 46.1632 43.193 45.4129 44.3031 44.3028C45.4132 43.1928 46.1634 41.7743 46.4563 40.232C48.5153 29.411 48.5153 18.589 46.4563 7.768C46.1634 6.22569 45.4132 4.80723 44.3031 3.69716C43.193 2.5871 41.7746 1.83684 40.2323 1.544C34.8821 0.520449 29.4474 0.00349601 24.0002 0C18.5531 0.00349601 13.1184 0.520449 7.76825 1.544Z",
                        );
                        iconPath.setAttribute("clip-rule", "evenodd");
                        iconPath.setAttribute("fill-rule", "evenodd");
                        iconPath.setAttribute("fill", "#EA1B0A");
                        iconSvg.appendChild(iconPath);
                        button.appendChild(iconSvg);
                    });
                }, 2000);
            },
            deactivateMarker() {
                // this.hideCircle();
                this.markerActive = false;
                // this.$refs.GMCircle.circle.setVisible(false);
                this.$refs.GMWindow.infoWindow.close(this.$refs.GMap.map);
                if (this.activeAreaId) {
                    this.hideArea(this.activeAreaId);
                    this.activeAreaId = null;
                }
            },
        },

        emits: ["update:api"],

        components: {
            GoogleMap,
            CustomMarker,
            MarkerCluster,
            InfoWindow,
            GPolygon,
            GPolyline,
            GCircle,
        },

    };
</script>
<style lang="less">
@import "../assets/theme/variable.less";
.gm-style .gm-style-iw-tc {
    display: none;
}
.marker {
    width: 32px;
}
.marker-amount {
    width: 24px;
    height: 24px;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    top: -50%;
    right: -50%;
    transform: translate(-25%, 25%);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.75rem;
    padding: 4px 6px;
}
.planned-marker-amount {
    border: 1px solid @tint-bordeaux-00;
}
.confirmed-marker-amount {
    border: 1px solid @color-red;
}
.gm-style div {
    border: none !important;
}
.gm-style .gm-style-iw-c {
    border-radius: 4px;
    padding: 0 !important;
}
.gm-style-iw-c {
    &:focus-visible {
        outline: none;
    }
}
.gm-style-iw-chr {
    height: 0;
}
.gm-style-iw-d {
    overflow: hidden !important;
    text-align: left;
    &:focus-visible {
        outline: none;
    }
}
.gm-ui-hover-effect {
    z-index: 1;
    top: -5px !important;
    right: 5px !important;
    & > span {
        background-color: white;
    }
    @media screen and (max-width: 900px) {
        &:focus {
            outline: none;
            box-shadow: none;
        }
    }
}
.info-window-extensive {
    width: 441px;
    min-height: 250px;
    @media screen and (max-width: 800px) {
        width: 400px;
    }
    @media screen and (max-width: 600px) {
        width: 300px;
    }
    @media screen and (max-width: 500px) {
        width: auto;
    }
}
.info-window {
    &:focus-visible {
        outline: none;
    }
    width: 441px;
    @media screen and (max-width: 800px) {
        width: 400px;
    }
    @media screen and (max-width: 600px) {
        width: 300px;
    }
    @media screen and (max-width: 500px) {
        width: auto;
    }
    min-height: 300px;
    display: flex;
    flex-direction: column;
    &-header {
        font-family: "Eon Brix Sans Web";
        font-size: 1.25rem;
        font-weight: 300;
        color: white;
        text-align: left;
        padding: 6px 20px 6px 15px;
        position: relative;
        @media screen and (max-width: 700px) {
            font-size: 1rem;
        }
        &-user {
            width: 300px;
            @media screen and (max-width: 500px) {
                width: auto;
            }
        }
        &__planned {
            background-color: @tint-bordeaux-00;
        }
        &__confirmed, &__extensive {
            background-color: @color-red;
        }
    }
    &-content {
        &:focus-visible {
            outline: none;
        }
        display: flex;
        flex-grow: 1;
        padding: 0 1rem;
        @media screen and (max-width: 800px) {
            padding: 0 0.5rem;
            flex-direction: column;
        }
        font-family: "Eon Brix Sans Web";
        &__planned, &__confirmed, &__user, &__extensive {
            background-size: cover;
            background-repeat: no-repeat;
        }
        &__user {
            width: 300px;
            @media screen and (max-width: 500px) {
                width: auto;
            }
            flex-direction: column;
            padding: 0;
            .info-window-header {
                background-color: @color-turquoise;
            }
            .info-window-content-text {
                width: 60%;
                margin-left: 2rem;
            }
        }
        &-text {
            background-color: rgba(255, 255, 255, 0.8);
            margin: 24px 0;
            padding: 16px 0;
            @media screen and (max-width: 800px) {
                margin-bottom: 10px;
                padding: 0 0;
            }
            &__date {
                flex: 0 0 50%;
                @media screen and (max-width: 800px) {
                    margin-top: 0;
                }
            }
        }
        &-address, &-start-data, &-end-data, &-comment, &-repair-time {
            font-size: 1rem;
            padding: 0 25px;
            font-weight: 900;
            margin-block-start: 0;
            margin-block-end: 0;
            color: @tint-grey-dark-01;

            @media screen and (max-width: 800px) {
                font-size: 0.875rem;
            }
            &-input, &-link {
                padding: 0 25px;
                font-size: 1rem;
                margin-block-start: 0.3em;
                margin-block-end: 0.3em;
                color: @tint-grey-dark-01;
                text-transform: uppercase;

                @media screen and (max-width: 800px) {
                    font-size: 0.875rem;
                }
            }
        }

        &-repair-time {
            padding-bottom: 1em;
        }

        &-comment-input, &-comment-link {
            text-transform: none;
        }
        &-comment-link {
            font-weight: bold;
        }
        &-address, &-comment {
            margin-block-start: 0;
        }
        &-address {
            &__planned, &__confirmed, &__extensive {
                color: white;
                width: fit-content;
                padding: 4px 8px;
                border-radius: 4px;
                @media screen and (max-width: 800px) {
                    width: 100%;
                    font-size: 14px;
                }
            }
            &__planned {
                background-color: @tint-bordeaux-00;
            }
            &__confirmed, &__extensive {
                background-color: @color-red;
            }
        }
    }
    ul.info-window-content-address-input {
        list-style: none;
        overflow-y: auto;
        height: 150px;
        @media screen and (max-width: 800px) {
            height: fit-content;
            max-height: 120px;
            font-size: 0.75rem;
        }
        margin-top: 8px;
        color: @tint-grey-dark-01;
        text-transform: uppercase;
        &::-webkit-scrollbar {
            width: 10px;
        }
    }
}
.map {
    .mapdiv {
        .gm-style div[aria-hidden="true"] {
            width: 24px;
            height: 24px;
            background-color: white;
            border-radius: 50%;
            position: absolute;
            top: 23%;
            transform: translateX(11%);
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.75rem !important;
            padding: 4px 6px;
            border: 1px solid @secondary-color !important;
            color: @secondary-color !important;
        }
    }
}
html[data-font-size='2'] {
    .gm-style .gm-style-iw-c {
        max-width: 1000px !important;
        width: 80%;
        .info-window {
            width: unset;
        }
    }
}
</style>
